import {
    Fragment,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IProgressTrackProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ProgressPartContentProps
} from "../../type";
import {
    Circle,
    Svg
} from "react-native-svg";
import {
    withProgressContext
} from "../../context";
import {
    getProgressRing
} from "../../stylesheet";
import ProgressIndicator from "../indicator";
import Text from "../../../text";

const ProgressTrackContent: FC<ProgressPartContentProps<IProgressTrackProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        shapeConfigs,
        radiuses,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isCircular = context.variant === "circular";

    const ring = getProgressRing({
        currentSize: context.currentSize
    });

    const {
        track: trackDynamicStyle
    } = useStyles({
        currentColors: context.currentColors,
        currentSize: context.currentSize,
        variant: context.variant,
        shapeConfigs,
        radiuses,
        spaces
    });

    const isShowRingValue = context.size === "large" && context.isValueVisible && !context.isIndeterminate && !!context.valueText;

    const renderCircularContent = () => {
        return <Fragment>
            <Svg
                height={context.currentSize.diameter}
                width={context.currentSize.diameter}
                style={stylesheet.ringLayer}
            >
                <Circle
                    stroke={context.currentColors.trackColor}
                    strokeWidth={context.currentSize.stroke}
                    cx={ring.center}
                    cy={ring.center}
                    r={ring.radius}
                    fill="none"
                />
            </Svg>
            {
                children ?? <Fragment>
                    <ProgressIndicator />
                    {
                        isShowRingValue ?
                            <Text
                                customColor={context.currentColors.ringValueColor}
                                style={stylesheet.ringValue}
                                customTheme={customTheme}
                                variant="labelSmallSize"
                                aria-hidden={true}
                            >
                                {context.valueText}
                            </Text>
                        :
                            null
                    }
                </Fragment>
            }
        </Fragment>;
    };

    return <View
        {...props}
        aria-labelledby={context.title && !isCircular ? context.titleID : undefined}
        aria-valuenow={context.isIndeterminate ? undefined : context.value}
        style={[
            style,
            isCircular ? stylesheet.ring : stylesheet.track,
            trackDynamicStyle
        ]}
        role={context.isMeter ? "meter" : "progressbar"}
        aria-valuetext={context.accessibleValueText}
        aria-label={context.accessibleName}
        aria-valuemax={context.max}
        aria-valuemin={0}
    >
        {isCircular ? renderCircularContent() : children ?? <ProgressIndicator />}
    </View>;
};
export default withProgressContext("Track", ProgressTrackContent);
